import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { RelationsReadApiClient } from '~/services/Http';

import { RelationsDto } from '../../client.people.generated';

export const GET_RELATIONS_SWR_KEY = 'RelationsReadApiClient.getRelations';

export function useGetRelations(
  args?: {
    lang?: string;
    employmentIds?: number[];
    employeeIds?: number[];
  },
  swrConfig?: SWRConfiguration<RelationsDto>,
): UseSWROutput<RelationsDto> {
  return useSWR(
    [
      GET_RELATIONS_SWR_KEY,
      args?.lang ?? undefined,
      args?.employmentIds ?? undefined,
      args?.employeeIds ?? undefined,
    ],
    ([_, lang, employmentIds, employeeIds]) =>
      RelationsReadApiClient.getRelations(
        lang,
        employmentIds,
        employeeIds,
      ).then((r) => r),
    swrConfig,
  );
}
